{
  "nav.startHere": "Start Here",
  "nav.about": "About",
  "nav.protocols": "Protocols",
  "nav.tools": "Tools",
  "nav.compliance": "Compliance",
  "nav.personal": "Personal Protocol",
  "nav.organization": "Organization Protocol",
  "nav.mission": "Mission & Vision",
  "nav.scope": "Scope & Non-Guarantee",
  "nav.standards": "Standards Mapping",
  "nav.changelog": "Changelog",
  "nav.governance": "Governance",
  "nav.disclaimer": "Legal Disclaimer",
  "nav.contact": "Contact Us",
  
  "hero.title1": "Secure Your",
  "hero.title2": "Digital World",
  "hero.subtitle": "A global cybersecurity protocol and readiness platform for individuals and organizations. Based on industry-standard practices and global security frameworks.",
  "hero.cta.start": "Start Security Assessment",
  "hero.cta.learn": "Learn More",
  "hero.trust.standards": "Standards-Aligned",
  "hero.trust.standardsDesc": "Global best practices",
  "hero.trust.defensive": "Defensive Only",
  "hero.trust.defensiveDesc": "Ethical security guidance",
  "hero.trust.global": "Global Platform",
  "hero.trust.globalDesc": "International protocols",
  
  "home.tab.personal": "Personal Protocol",
  "home.tab.organization": "Organization Protocol",
  "home.personal.title": "Start with these 10 steps",
  "home.personal.desc": "Essential security controls every individual must implement immediately to prevent 90% of common attacks.",
  "home.org.title": "Organizational Security Baseline",
  "home.org.desc": "Essential governance and technical controls every organization should establish to reduce cyber risk and improve resilience.",
  "home.org.note": "These steps represent a minimum baseline that organizations can implement immediately, regardless of size or industry.",
  "home.checklist.title": "10 Essential Steps",
  "home.principle1.title": "Defense in Depth",
  "home.principle1.titleOrg": "Layered Security",
  "home.principle1.desc": "Apply multiple, independent security controls so that the failure of a single control does not compromise overall security.",
  "home.principle1.descOrg": "Multiple independent controls so that if one fails, others remain effective.",
  "home.principle2.title": "Zero Trust Mindset",
  "home.principle2.titleOrg": "Continuous Verification",
  "home.principle2.desc": "Do not rely on implicit trust. Continuously verify access based on identity, device, and context.",
  "home.principle2.descOrg": "Verify every access request and assume potential compromise at all times.",
  "home.standards.badge": "Standards-Based Approach",
  "home.standards.title": "Built on Global Security Standards",
  "home.standards.desc": "Our protocols are rigorously aligned with internationally recognized cybersecurity frameworks and best practices.",
  "home.standards.risk.title": "Risk Management",
  "home.standards.risk.desc": "Comprehensive risk-based approach to cybersecurity governance and operational resilience.",
  "home.standards.risk.functions": "Govern, Identify, Protect, Detect, Respond, Recover",
  "home.standards.controls.title": "Security Controls",
  "home.standards.controls.desc": "International standard for Information Security Management Systems with comprehensive controls.",
  "home.standards.controls.count": "114 security controls across 14 domains",
  "home.standards.practices.title": "Best Practices",
  "home.standards.practices.desc": "Prioritized, actionable security controls to defend against the most common cyber attacks.",
  "home.standards.practices.count": "18 critical security controls",
  "home.standards.cta": "View Complete Standards Mapping",
  
  "start.badge": "Choose Your Assessment Path",
  "start.title": "Security Risk Assessment",
  "start.subtitle": "Select your assessment type to receive a tailored cybersecurity protocol, prioritized action plan, and risk mitigation roadmap.",
  "start.disclaimer": "This assessment provides practical guidance and prioritization, not a guarantee of complete security.",
  "start.personal.badge": "Personal",
  "start.personal.title": "Personal Security Risk Assessment",
  "start.personal.desc": "Take this 3-minute assessment to evaluate your personal cybersecurity risk based on your accounts, devices, and daily digital habits.",
  "start.personal.benefit1": "A personalized personal security protocol",
  "start.personal.benefit2": "A prioritized checklist for your devices and accounts",
  "start.personal.benefit3": "Immediate actions to reduce common cyber risks",
  "start.personal.audience": "Designed for individuals, professionals, and everyday users.",
  "start.personal.cta": "Start Personal Assessment",
  "start.org.badge": "Organization",
  "start.org.title": "Organizational Cybersecurity Risk Assessment",
  "start.org.desc": "Complete this 3-minute assessment to evaluate your organization's cybersecurity posture across identity, devices, data protection, and incident readiness.",
  "start.org.benefit1": "A tailored organizational security protocol",
  "start.org.benefit2": "A prioritized 30/60/90-day improvement roadmap",
  "start.org.benefit3": "Key control gaps aligned with global standards",
  "start.org.audience": "Designed for companies, NGOs, schools, and institutions of all sizes.",
  "start.org.cta": "Start Organization Assessment",
  "start.trust.time": "3-minute assessment",
  "start.trust.standards": "Standards-aligned protocols",
  "start.trust.results": "Immediate actionable results",
  "start.youWillReceive": "You will receive:",
  
  "personal.title": "Personal Security Protocol",
  "personal.subtitle": "A comprehensive defense strategy built on 6 core pillars. Implement these controls to secure your digital life against modern threats.",
  
  "org.badge": "Organizational Security Protocol",
  "org.title": "Organizational",
  "org.titleHighlight": "Security Protocol",
  "org.subtitle": "A structured, best-practice security protocol to help organizations reduce cyber risk, protect critical assets, and improve resilience.",
  "org.cta.start": "Start Security Protocol",
  "org.cta.assessment": "Take Risk Assessment",
  "org.why.title1": "Business Continuity",
  "org.why.desc1": "Ensure your organization can withstand and recover from cyber attacks without crippling downtime.",
  "org.why.title2": "Regulatory Compliance",
  "org.why.desc2": "Meet obligations under data protection laws and industry standards to avoid fines and legal issues.",
  "org.why.title3": "Customer Trust",
  "org.why.desc3": "Demonstrate commitment to security to build confidence with clients and partners.",
  "org.domains.title": "Core Security Domains",
  "org.domain.govern.title": "Governance & Leadership",
  "org.domain.govern.desc": "Establish security ownership, policies, and decision-making structures to guide your security program.",
  "org.domain.identify.title": "Assets & Risk Awareness",
  "org.domain.identify.desc": "Identify and understand your critical assets, data, and risks to prioritize protection efforts.",
  "org.domain.protect.title": "Protection & Prevention",
  "org.domain.protect.desc": "Implement safeguards like access controls, endpoint security, and backups to reduce risk.",
  "org.domain.detect.title": "Detection & Monitoring",
  "org.domain.detect.desc": "Set up logging and monitoring to detect suspicious activity and security incidents early.",
  "org.domain.respond.title": "Incident Response",
  "org.domain.respond.desc": "Prepare to respond effectively when security incidents occur with clear procedures and roles.",
  "org.domain.recover.title": "Recovery & Improvement",
  "org.domain.recover.desc": "Plan for recovery from incidents and continuously improve your security posture.",
  "org.domain.viewProtocol": "View Protocol",
  "org.roadmap.title": "Implementation Roadmap",
  "org.roadmap.subtitle": "A practical 90-day approach to building organizational security. Start with high-impact basics and progressively strengthen your defenses.",
  "org.roadmap.phase1.title": "First 30 Days: Foundation",
  "org.roadmap.phase1.item1": "Appoint security owner and define roles",
  "org.roadmap.phase1.item2": "Enable MFA for all critical accounts",
  "org.roadmap.phase1.item3": "Implement 3-2-1 backup strategy",
  "org.roadmap.phase1.item4": "Establish basic security policy",
  "org.roadmap.phase1.item5": "Create asset inventory",
  "org.roadmap.phase2.title": "Days 31-60: Visibility & Protection",
  "org.roadmap.phase2.item1": "Deploy endpoint protection on all devices",
  "org.roadmap.phase2.item2": "Enable logging on critical systems",
  "org.roadmap.phase2.item3": "Conduct security awareness training",
  "org.roadmap.phase2.item4": "Review and document vendor access",
  "org.roadmap.phase2.item5": "Implement patch management process",
  "org.roadmap.phase3.title": "Days 61-90: Response & Resilience",
  "org.roadmap.phase3.item1": "Create incident response plan",
  "org.roadmap.phase3.item2": "Conduct tabletop exercise",
  "org.roadmap.phase3.item3": "Test backup restoration",
  "org.roadmap.phase3.item4": "Perform quarterly access reviews",
  "org.roadmap.phase3.item5": "Document lessons learned and improvements",
  
  "risk.breadcrumb": "Risk Assessment",
  "risk.personal.badge": "Personal Assessment",
  "risk.personal.title": "Personal Security Risk Assessment",
  "risk.personal.desc": "Evaluate your personal cybersecurity risk based on your accounts, devices, and daily digital habits. Receive a personalized security protocol and prioritized action checklist.",
  "risk.org.badge": "Organization Assessment",
  "risk.org.title": "Organizational Cybersecurity Risk Assessment",
  "risk.org.desc": "Evaluate your organization's cybersecurity posture across identity, devices, data protection, and incident readiness. Receive a tailored protocol and 30/60/90-day improvement roadmap.",
  "risk.disclaimer": "This assessment provides practical guidance and prioritization, not a guarantee of complete security.",
  
  "tools.title": "Tools Library",
  "tools.subtitle": "Curated list of official, reputable tools to check your exposure and secure your accounts.",
  "tools.warning.title": "Warning:",
  "tools.warning.desc": "Never use unofficial breach databases or download leaked data. The tools listed below are legal, safe, and use privacy-preserving methods (like k-anonymity) to check your status.",
  
  "footer.brand.desc": "A global cybersecurity protocol and readiness platform for individuals and organizations.",
  "footer.brand.note": "Standards-aligned defensive security guidance.",
  "footer.protocols": "Protocols",
  "footer.resources": "Resources",
  "footer.about": "About",
  "footer.riskAssessment": "Risk Assessment",
  "footer.toolsLibrary": "Tools Library",
  "footer.complianceGuides": "Compliance Guides",
  "footer.standardsMapping": "Standards Mapping",
  "footer.missionVision": "Mission & Vision",
  "footer.scopeDisclaimer": "Scope & Disclaimer",
  "footer.contact": "Contact",
  "footer.copyright": "CyberSecurityProtocol. All rights reserved.",
  "footer.educational": "Educational and defensive cybersecurity guidance only.",
  "footer.legal": "Legal",
  "footer.nonGuarantee": "Non-Guarantee",
  "footer.builtBy": "Built by UXER — Part of Asosiasi Teknologi Informasi dan Open Source (ATIOS)",
  
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.continue": "Continue",
  "common.back": "Back",
  "common.next": "Next",
  "common.finish": "Finish",
  "common.viewMore": "View More",
  "common.learnMore": "Learn More",
  "common.getStarted": "Get Started"
}